import React from 'react';

import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';

import { isDefined } from '@hsp/utilities';

import ClientError from 'components/error/client-error.component';
import { ReduxRoot } from 'components/redux';
import { AppRouter } from 'components/router';
import { registerIcons } from 'utilities/font-awesome/library';

const onErrorHandler = (error: Error, { componentStack }: React.ErrorInfo): void => {
  // TODO: send log info to server
  // eslint-disable-next-line no-console
  console.error(error, componentStack);
};

const rootElement = document.getElementById('root');

if (!isDefined(rootElement)) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(rootElement);

const app = (
  <ReduxRoot>
    <ErrorBoundary
      FallbackComponent={ClientError}
      onError={onErrorHandler}>
      <AppRouter />
    </ErrorBoundary>
  </ReduxRoot>
);

registerIcons();

root.render(app);
